<template>
  <div class="container">
    <div class="title">
      成交數據
    </div>
    <!-- 筛选搜索 -->
    <div class="filter">
      <div>
        <el-row>
          <el-col>
            <el-input
              v-model="propertyNo"
              class="w180"
              maxlength="20"
              placeholder="物業編號"
            />
            <el-select
              v-model="categoryValue"
              class="w120 seled"
              placeholder="樓盤類型"
            >
              <el-option
                class="property-tags-cascader-none-li"
                label="全部"
                value="0"
              />
              <el-cascader-panel
                ref="cascader"
                v-model="category"
                :options="categoryList"
                :show-all-levels="false"
                class="property-tags-cascader-panelcheckbox"
                collapse-tags
                :props="{
                  multiple: true,
                  children: 'children',
                  value: 'dictionaryValue',
                  label: 'dictionaryNameWithCulture',
                  checkStrictly: false
                }"
                clearable
                @change="categoryCascaderChange"
              />
            </el-select>
            <!-- 区域 地区 片区 -->
            <el-select
              v-model="regionCode"
              class="w150 seled"
              placeholder="請選擇區域"
              @change="changeLinkage('region')"
            >
              <el-option
                v-for="(item, index) in regionList"
                :key="index+2"
                :label="item.gscopeNameWithCulture"
                :value="item.gscopeCode"
              />
            </el-select>
            <el-select
              v-model="zoneCode"
              class="w150 seled"
              filterable
              placeholder="請輸入/選擇地區"
              no-data-text="暫無數據"
              @change="changeLinkage('zone')"
            >
              <el-option
                v-for="(item, index) in zoneList"
                :key="index+1"
                :label="item.gscopeNameWithCulture"
                :value="item.gscopeCode"
              />
            </el-select>
            <el-select
              v-model="gscopeCode"
              class="w150 seled"
              placeholder="請輸入/選擇片區"
              filterable
              no-data-text="暫無數據"
            >
              <el-option
                v-for="(item,index) in gscopeList"
                :key="index+3"
                :label="item.gscopeNameWithCulture"
                :value="item.gscopeCode"
              />
            </el-select>
            <!-- 屋苑名称 -->
            <el-autocomplete
              v-model="estateName"
              class="w320 left_negative10 seled"
              :fetch-suggestions="search"
              placeholder="請輸入/選擇屋苑名稱"
              @select="setSelEstate"
              @blur="cancelSearch"
            />
          </el-col>

          <el-col>
            <div class="input-model w245">
              <el-input
                v-model="minRentPrice"
                class="w90"
                placeholder="最少租價"
                @blur="priceChange('rent')"
              />
              <span class="pm">-</span>
              <el-input
                v-model="maxRentPrice"
                class="w90"
                placeholder="最多租價"
                @blur="priceChange('rent')"
              />
              <span class="pm">元</span>
            </div>
            <div class="input-model w245">
              <el-input
                v-model="minSalePrice"
                class="w90"
                placeholder="最少售價"
                @blur="priceChange('sale')"
              />
              <span class="pm">-</span>
              <el-input
                v-model="maxSalePrice"
                class="w90"
                placeholder="最多售價"
                @blur="priceChange('sale')"
              />
              <span class="pm">萬</span>
            </div>
            <div class="input-model">
              <el-input
                v-model="minSaleableArea"
                class="w105"
                placeholder="最少實用面積"
              />
              <span class="pm">-</span>
              <el-input
                v-model="maxSaleableArea"
                class="w105"
                placeholder="最多實用面積"
              />
              <span class="pm">呎</span>
            </div>
            <div class="input-model">
              <el-input
                v-model="minBuildingArea"
                class="w105"
                placeholder="最少建築面積"
              />
              <span class="pm">-</span>
              <el-input
                v-model="maxBuildingArea"
                class="w105"
                placeholder="最多建築面積"
              />
              <span class="pm">呎</span>
            </div>
          </el-col>

          <el-col>
            <el-input
              v-model="accountName"
              class="w150"
              placeholder="請輸入操作人"
            />
            <span class="time">成交/註冊日期：</span>
            <el-date-picker
              v-model="minDealDate"
              class="w150 mr4"
              format="yyyy/MM/dd"
              value-format="timestamp"
              :picker-options="publicTimeOption2"
              type="date"
              placeholder="選擇日期"
            />-
            <el-date-picker
              v-model="maxDealDate"
              class="w150"
              format="yyyy/MM/dd"
              value-format="timestamp"
              :picker-options="publicTimeOption"
              type="date"
              placeholder="選擇日期"
            />
            <span class="time">提交日期：</span>
            <el-date-picker
              v-model="minCreateTime"
              class="w150 mr4"
              format="yyyy/MM/dd"
              value-format="timestamp"
              :picker-options="dealTimeOption2"
              type="date"
              placeholder="選擇日期"
            />-
            <el-date-picker
              v-model="maxCreateTime"
              class="w150"
              format="yyyy/MM/dd"
              value-format="timestamp"
              :picker-options="dealTimeOption"
              type="date"
              placeholder="選擇日期"
            />
            <span class="btn-filter">
              <el-button
                type="danger"
                @click="clickSearch"
              >查詢</el-button>
              <el-button
                type="info"
                @click="resetSearch"
              >重置</el-button>
            </span>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="line" />
    <!-- 功能按钮 -->
    <div :class="{ button: true, fixed: !isFixed && !sideBar, 'fixed-1': isFixed, 'fixed-2': !sideBar }">
      <span>
        <span
          class="span"
          @click="addDealData"
        >
          <svg
            class="icon"
            aria-hidden="true"
          >
            <use xlink:href="#iconkandengloupan1-copy" />
          </svg>
          <span class="btn-text">添加成交紀錄</span>
        </span>
      </span>
    </div>
    <div
      v-if="isFixed"
      class="button2"
    />
    <!-- 数据表格 -->
    <div class="table">
      <div class="text-list">
        <el-table
          v-loading="firstLoading"
          :data="dealTableData"
          empty-text="暫無數據"
          style="width: 100%"
          :header-cell-style="{ background: 'rgba(80,181,255,0.15)', color: '#444' }"
        >
          <el-table-column
            fixed="right"
            label="操作"
            width="120"
            class-name="fixColumm"
          >
            <template slot-scope="scope">
              <span>
                <el-button
                  :class="['editBut']"
                  type="primary"
                  size="small"
                  @click="editDealData(scope.row)"
                >編輯</el-button>
              </span>
              <el-dropdown
                ref="dropdown"
                trigger="click"
                :hide-on-click="true"
              >
                <span :class="['marBut']">
                  <el-button
                    class="expandBut"
                    icon="el-icon-caret-bottom"
                  />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div
                      :class="['span', { disspan: !scope.row.verifyFile }]"
                      @click="showFile(scope.row)"
                    >
                      <svg
                        class="icon"
                        aria-hidden="true"
                      >
                        <use :xlink:href="!scope.row.verifyFile ? '#iconwenjian-copy' : '#iconwenjian'" />
                      </svg>
                      <span :class="{ 'btn-text': true, ban: !scope.row.verifyFile }">查看文件</span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div
                      :class="['span', { disspan: !scope.row.verifyFile }]"
                      @click="downloadFile(scope.row)"
                    >
                      <svg
                        class="icon"
                        aria-hidden="true"
                      >
                        <use :xlink:href=" !scope.row.verifyFile ? '#iconxiazai-copy' : '#iconxiazai'" />
                      </svg>
                      <span :class="{ 'btn-text': true, ban:!scope.row.verifyFile }">下載文件</span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div
                      :class="['span']"
                      @click="delFile(scope.row)"
                    >
                      <svg
                        class="icon"
                        aria-hidden="true"
                      >
                        <use xlink:href="#iconshanchu1-copy" />
                      </svg>
                      <span :class="{ 'btn-text': true }">刪除</span>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <el-table-column
            label="物業編號"
            width="120"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.propertyNo"
                class="btn-a"
              >{{ scope.row.propertyNo }}</span>
              <span
                v-else
                class="btn-a"
              >-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="樓盤類型"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.propertyCategory">{{ formatProperCat(scope.row.propertyCategory, scope.row.subCategory) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="地區"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.zoneName">{{ scope.row.zoneName }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="屋苑名稱"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.estateName">{{ scope.row.estateName }}&nbsp;{{ scope.row.phaseWithCulture }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="樓盤地址"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.estateName">{{ scope.row.estateName }}&nbsp;{{ scope.row.phaseWithCulture }}&nbsp;{{ scope.row.buildingName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="街道號碼"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.estateAddress">{{ scope.row.estateAddress }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="售價（萬）"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.salePrice">{{ scope.row.salePrice/10000 }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="租價（元）"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.rentPrice">{{ scope.row.rentPrice }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="面積"
            width="120"
          >
            <template slot-scope="scope">
              <span>
                <p v-if="scope.row.saleableArea">實用面積: {{ scope.row.saleableArea }}</p>
                <p v-if="scope.row.buildingArea">建築面積: {{ scope.row.buildingArea }}</p>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="成交/註冊日期"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.dealDate">{{ scope.row.dealDate.substring(0, scope.row.dealDate.indexOf('T')) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="提交時間"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.createTime">{{ scope.row.createTime.substring(0, scope.row.createTime.indexOf('T')) }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="House730放盤所用樓盤編號"
            width="120"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.propertyID"
                class="btn-a"
              >{{ scope.row.propertyID }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="是否有成交文件"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.verifyFile && scope.row.verifyFile.length">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作人"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.name">{{ scope.row.name }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          class="page"
          background
          :page-size="pageCount"
          :page-sizes="[10, 20, 50, 100]"
          layout="total,sizes,prev, pager, next,jumper"
          :current-page.sync="pageIndex"
          :total="count"
          @size-change="sizeChange"
          @current-change="currentChange"
        />
      </div>
    </div>
    <div class="left-right-scorll">
      <span onselectstart="return false">
        <svg
          class="icon"
          aria-hidden="true"
          @click="clicRightScroll('text-list')"
        >
          <use xlink:href="#iconzuo" />
        </svg>
      </span>
      <span onselectstart="return false">
        <svg
          class="icon"
          aria-hidden="true"
          @click="clicLeftScroll('text-list')"
        >
          <use xlink:href="#iconyou" />
        </svg>
      </span>
    </div>
    <!-- 表单提交 -->
    <el-dialog
      top="25vh"
      class="dealclass"
      title="添加成交數據"
      width="960px"
      :close-on-click-modal="false"
      :visible.sync="isShowDeal"
      @close="cancelDeal"
    >
      <div class="deal-tishi">
        <el-form
          ref="dealFormData"
          :model="dealFormData"
          :rules="rules"
        >
          <div style="width:80%">
            <el-row
              :gutter="20"
              class="deal-row"
            >
              <el-col :span="11">
                <el-form-item
                  label="樓盤類型："
                  prop="propertyCategoryArr"
                >
                  <el-cascader
                    v-model="dealFormData.propertyCategoryArr"
                    class="w180"
                    :options="categoryList"
                    value="dictionaryValue"
                    :props="{
                      children: 'children',
                      value: 'dictionaryValue',
                      label: 'dictionaryNameWithCulture',
                      checkStrictly: false
                    }"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item
                  label="物業編號："
                  prop="propertyNo"
                >
                  <el-input
                    v-model="dealFormData.propertyNo"
                    class="w180"
                    maxlength="20"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="20"
              class="deal-row"
            >
              <el-col :span="11">
                <el-form-item
                  label="屋苑或大廈名稱："
                  prop="estateName"
                >
                  <el-autocomplete
                    v-model="dealFormData.estateName"
                    class="w180"
                    :fetch-suggestions="search"
                    placeholder="搜尋：屋苑或大廈名稱"
                    @select="setEstate"
                    @blur="cancelSearch"
                  />
                </el-form-item>
              </el-col>
              <el-col
                v-if="phaseEstates.length"
                :span="9"
              >
                <el-form-item
                  label="期數："
                  prop="phaseWithCulture"
                >
                  <el-select
                    v-model="dealFormData.phaseWithCulture"
                    class="w180"
                    placeholder="請選擇期數"
                    no-data-text="暫無數據"
                    @change="forceChange"
                  >
                    <el-option
                      v-for="(item, index) in phaseEstates"
                      :key="index"
                      :label="item.phaseWithCulture"
                      :value="item.phaseWithCulture"
                      @click.native="phachange(item)"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="20"
              class="deal-row"
            >
              <el-col :span="11">
                <el-form-item
                  label="座數："
                  prop="buildingName"
                >
                  <el-input
                    v-model="dealFormData.buildingName"
                    class="w180"
                    @input="forceChange"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item
                  label="樓層："
                  prop="floorName"
                >
                  <el-select
                    v-model="dealFormData.floorName"
                    class="w180"
                    placeholder="請選擇樓層"
                    @change="forceChange"
                  >
                    <el-option
                      v-for="(item, index) in floorList"
                      :key="index"
                      :label="item.dictionaryNameWithCulture"
                      :value="item.dictionaryNameWithCulture"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="20"
              class="deal-row"
            >
              <el-col :span="11">
                <el-form-item
                  label="單位："
                  prop="roomNo"
                >
                  <el-input
                    v-model="dealFormData.roomNo"
                    class="w180"
                    @input="forceChange"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item
                  label="樓齡："
                  prop="buildingAge"
                >
                  <el-input
                    v-model="dealFormData.buildingAge"
                    class="w180"
                    @input="forceChange"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="20"
              class="deal-row"
            >
              <el-col :span="20">
                <el-form-item
                  label="街道號碼："
                  prop="estateAddress"
                >
                  <el-input
                    v-model="dealFormData.estateAddress"
                    class="w180"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="20"
              class="deal-row"
            >
              <el-col :span="11">
                <el-form-item
                  label="售價(萬)："
                  prop="salePrice"
                >
                  <el-input
                    v-model.trim="dealFormData.salePrice"
                    class="w180"
                    @input="forceChange"
                    @blur="handleReqChange('salePrice', 'rentPrice')"
                  />
                  <div style="display: inline-block; line-height: 25px; vertical-align: middle; margin-left: 4px">
                    <div>根據實際業務</div>
                    <div>價格選擇填寫</div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item
                  label="租價(元)："
                  prop="rentPrice"
                >
                  <el-input
                    v-model.trim="dealFormData.rentPrice"
                    class="w180"
                    @input="forceChange"
                    @blur="handleReqChange('rentPrice', 'salePrice')"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="20"
              class="deal-row"
            >
              <el-col :span="12">
                <el-form-item
                  label="實用面積(呎)："
                  prop="saleableArea"
                >
                  <el-input
                    v-model.trim="dealFormData.saleableArea"
                    class="w180"
                    @input="forceChange"
                    @blur="handleReqChange('saleableArea', 'buildingArea')"
                  />
                  <div style="display: inline-block; line-height: 25px; vertical-align: middle; margin-left: 4px">
                    <div>實用面積和建築面積</div>
                    <div>最少填寫一項</div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col
                :span="9"
                class="areaspan"
              >
                <el-form-item prop="buildingArea">
                  <template #label>
                    <span>建築面積(呎)：</span>
                  </template>
                  <el-input
                    v-model.trim="dealFormData.buildingArea"
                    class="w180"
                    @input="forceChange"
                    @blur="handleReqChange('buildingArea', 'saleableArea')"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="20"
              class="deal-row"
            >
              <el-col :span="11">
                <el-form-item
                  label="房間數目："
                  prop="roomNumber"
                >
                  <el-select
                    v-model="dealFormData.roomNumber"
                    placeholder="不提供"
                    no-data-text="暫無數據"
                    class="w180"
                    @change="forceChange"
                  >
                    <el-option
                      v-for="item in roomNumber"
                      :key="item.dictionaryValue"
                      :label="item.dictionaryNameWithCulture"
                      :value="item.dictionaryValue"
                      placeholder="不提供"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item
                  label="洗手間數目："
                  prop="toiletNumber"
                >
                  <el-select
                    v-model="dealFormData.toiletNumber"
                    placeholder="不提供"
                    no-data-text="暫無數據"
                    class="w180"
                    @change="forceChange"
                  >
                    <el-option
                      v-for="item in toiletNumber"
                      :key="item.dictionaryValue"
                      :label="item.dictionaryNameWithCulture"
                      :value="item.dictionaryValue"
                      placeholder="不提供"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="20"
              class="deal-row"
            >
              <el-col :span="20">
                <el-form-item
                  label="成交/註冊日期："
                  prop="dealDate"
                >
                  <el-date-picker
                    v-model="dealFormData.dealDate"
                    value-format="yyyy-MM-dd"
                    class="w180"
                    type="date"
                    placeholder="選擇日期"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="20"
              class="deal-row"
            >
              <el-col
                :span="20"
                class="labelspan"
              >
                <el-form-item prop="propertyID">
                  <template #label>
                    <span>House730放盤<br>所用樓盤編號(如有)：</span>
                  </template>
                  <el-input
                    v-model="dealFormData.propertyID"
                    class="w180"
                    @input="forceChange"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="20"
              class="deal-row"
            >
              <el-col :span="20">
                <el-form-item label="成交驗證文件(如有)：">
                  <!-- :on-preview="handleChange" -->
                  <el-upload
                    ref="uploadFile"
                    class="upload-demo"
                    action="#"
                    :limit="5"
                    :http-request="upfiles"
                    :on-exceed="handleExceed"
                    :before-upload="beforeUpload"
                    :file-list="filelist"
                    :on-remove="onRemove"
                    multiple
                  >
                    <el-button
                      size="small"
                      type="primary"
                    >
                      上傳文件
                    </el-button>
                  </el-upload>
                </el-form-item>
              </el-col>
              <div class="tip">
                支援格式：.pdf  .jpg  .png  .docx
              </div>
            </el-row>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="cancelDeal">
          取 消
        </el-button>
        <el-button
          type="primary"
          @click="validation('dealFormData')"
        >
          確 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    components: {},
    data() {
        return {
            firstLoading: true,
            // 成交表单数据
            dealFormData: {
                phaseWithCulture: '',
                propertyCategoryArr: [],
                propertyCategory: '',
                subCategory: '',
                propertyNo: '',
                estateName: '',
                parentEstateID: '',
                estateID: '', //期数
                buildingName: '',
                floorName: '',
                roomNo: '',
                buildingAge: '',
                estateAddress: '',
                salePrice: '',
                rentPrice: '',
                saleableArea: '',
                buildingArea: '',
                roomNumber: '',
                toiletNumber: '',
                dealDate: null,
                propertyID: null,
                verifyFile: []
            },
            // 表单校验规则
            rules: {
                propertyCategoryArr: [{ required: true, message: '請選擇樓盤類型', trigger: 'change' }],
                propertyNo: [{ required: true, message: '請填寫物業編號', trigger: 'blur' }],
                estateName: [{ required: true, message: '請選擇樓盤屋苑或大廈名稱', trigger: 'change' }],
                phaseWithCulture: [{ required: true, message: '請選擇期数', trigger: 'change' }],
                salePrice: [{ required: true, message: '請輸入放售價', trigger: 'blur' }],
                rentPrice: [{ required: true, message: '請輸入每月租金', trigger: 'blur' }],
                buildingArea: [{ required: true, message: '請輸入建築面積', trigger: 'blur' }],
                saleableArea: [{ required: true, message: '請輸入實用面積', trigger: 'blur' }],
                dealDate: [{ required: true, message: '請選擇成交/註冊日期', trigger: 'change' }]
            },
            //
            isShowDeal: false,
            scrollValue: 0,
            isFixed: false,
            floorList: [
                { dictionaryValue: 5, dictionaryNameWithCulture: '全棟' },
                { dictionaryValue: 1, dictionaryNameWithCulture: '高層' },
                { dictionaryValue: 2, dictionaryNameWithCulture: '中層' },
                { dictionaryValue: 3, dictionaryNameWithCulture: '低層' },
                { dictionaryValue: 4, dictionaryNameWithCulture: '地下' },
            ],
            phaseEstates: [],
            publicTimeOption: {
                disabledDate: this.publicTimeOption1
            },
            publicTimeOption2: {
                disabledDate: this.publicTimeOption3
            },
            dealTimeOption: {
                disabledDate: this.dealTimeOption1
            },
            dealTimeOption2: {
                disabledDate: this.dealTimeOption3
            },
            // 搜索数据项
            estate: [],
            pageIndex: 1,
            pageCount: 10,
            SubCategory: [],
            regionList: [],
            zoneList: [],
            gscopeList: [],
            categoryList: [],
            roomNumber:[],
            toiletNumber:[],
            propertyNo: '',
            categoryValue: '',
            category: '',
            categoryValueEnd: [],
            regionCode: '',
            zoneCode: '',
            gscopeCode: '',
            estateName: '', //待定
            accountName: '', //待定
            minRentPrice: '',
            maxRentPrice: '',
            minSalePrice: '',
            maxSalePrice: '',
            minSaleableArea: '',
            maxSaleableArea: '',
            minBuildingArea: '',
            maxBuildingArea: '',
            minDealDate: '',
            maxDealDate: '',
            minCreateTime: '',
            maxCreateTime: '',
            imgQueue: {},
            curQueue: {},
            filelist: [],
            //表单数据
            dealTableData: [],
            count: 0,
            viewMode: 'post'
        };
    },
    async created() {
        /**获取字典信息 */
        this.pub.getDictionary().then(res => {
            this.categoryList = res.PropertyCategory.children;
            this.roomNumber = res.RoomNumber.children;
            this.toiletNumber = res.ToiletNumber.children;
            this.roomNumber.unshift({
                dictionaryNameWithCulture: '不提供',
                dictionaryValue: null
            });
        });
        /**获取区域地区片区*/
        this.getGscope()
        
        this.pageCount = this.pub.getPageSize(this.$store.state.userInfo.accountID, 'dealPageCount') || 10;

        this.getTableData();
        
    },
    mounted() {
        document.querySelector('.el-main').addEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleChange(file, fileList){
            console.log("file:",file,"fileList",fileList)
        },
        forceChange(val){
            this.$forceUpdate();
        },
        async getGscope(){
            let resgscope = await this.axios.get(this.pub.getApi().GetGscope);
            if (resgscope.data.code === 0 && resgscope.data.result) {
                //regioncode 区域 zoonecode 地区 gscopecode 片区
                this.regionList = resgscope.data.result;
                this.regionList.forEach(item => {
                    this.zoneList.push(...item.children)
                });
                this.zoneList.forEach(item => {
                    this.gscopeList.push(...item.children)
                });
            }
        },
        addDealData() {
            this.$router.push({path:'/property/SubDeal'})
            // this.viewMode = 'post';
            // this.addformrule()
            // this.isShowDeal = true;
        },
        async getTableData() {
            // 不带有筛选条件
            await this.axios.post(this.pub.getApi().SearchPropertyDeal, { pageIndex: 1, pageCount: this.pageCount }).then(res => {
                if (res.data.code == 0) {
                    this.dealTableData = res.data.result.data;
                    this.firstLoading = false;
                    this.count = res.data.result.count;
                }
            });
        },
        formatProperCat(propertyCategory, subCategory) {
            let proCategory = '';
            let subCategoryText = '';
            for (let index = 0; index < this.categoryList.length; index++) {
                if (this.categoryList[index].dictionaryValue == propertyCategory) {
                    proCategory = this.categoryList[index].dictionaryNameWithCulture;
                    if (subCategory && this.categoryList[index].children) {
                        for (let i = 0; i < this.categoryList[index].children.length; i++) {
                            if (subCategory == this.categoryList[index].children[i].dictionaryValue) {
                                subCategoryText = '/' + this.categoryList[index].children[i].dictionaryNameWithCulture;
                            }
                        }
                    }
                }
            }
            return proCategory + subCategoryText;
        },
        // 表单回显
        editDealData(row) {
            this.$router.push({
                name: this.pub.routeNameLists.SubDeal,
                query: {
                    dealId: row.propertyDealID,
                    type: 'edit',
                }
            });
            return
        },

        showFile(row) {
            row.verifyFile.map(async item => {
                let type = await this.getFileType(item.filePath);
                let url = item.filePath.replace(/^https?:\/\//i, '//');
                if (type == 'image/jpeg' || type == 'image/png') {
                    url = url + '?x-oss-process=style/master';
                }
                this.fetchPreviewBlob(url,type)
            });
        },
        getFileType(url) {
            return new Promise((resolve, reject) => {
                const extension = url.split('.').pop().toLowerCase();
                switch (extension) {
                    case 'jpeg':
                    case 'jpg':
                        resolve('image/jpeg');
                        break;
                    case 'png':
                        resolve('image/png');
                        break;
                    case 'pdf':
                        resolve('application/pdf');
                        break;
                    case 'doc':
                    case 'docx':
                        resolve('application/msword');
                        break;
                    case 'xlsx':
                        resolve('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                        break;
                    default:
                        resolve('application/octet-stream');
                }
            });
        },
        fetchPreviewBlob(url, type) {
            fetch(url)
                .then(res => res.blob())
                .then(blob => {
                    if (type == 'application/msword') {
                        // 这里原本就是 let，保持不变
                        let docwindow = window.open('', 'DetailRunTime'); 
                        let box = document.createElement('div'); 
                        let docx = require('docx-preview');
                        docx.renderAsync(blob, box)
                            .then(() => {
                                docwindow.document.write(box.outerHTML);
                                docwindow.document.title = '成交文档'; 
                                docwindow.document.getElementsByClassName('docx')[0].style.width = 'auto';
                            })
                            .catch(error => console.error(error));
                    } else {
                        // 修改点：eslint 将 var 改为 const
                        // 注意：为了避免与参数 blob 重名导致混淆，换变量名
                        const finalBlob = new Blob([blob], { type: type });
                        const href = window.URL.createObjectURL(finalBlob); 
                        window.open(href);
                    }
                });
        },
        //获取blob文件流 下载文件
        fetchBlob(url, type, fileName) {
            fetch(url)
                .then(res => {
                    return res.blob();
                })
                .then(blob => {
                    const urlBlob = window.URL.createObjectURL(new Blob([blob], { type: type }));
                    const link = document.createElement('a');
                    // 下载
                    link.href = urlBlob;
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    window.URL.revokeObjectURL(link.href);
                });
        },
        downloadFile(row) {
            row.verifyFile.map(async item => {
                let type = await this.getFileType(item.filePath);
                let url = item.filePath.replace(/^https?:\/\//i, '//');
                if (type == 'image/jpeg' || type == 'image/png') {
                    url = url + '?x-oss-process=style/master';
                }
                this.fetchBlob(url,type,item.name)
            });
        },
        async delFile(row) {
            this.$confirm('確認刪除成交數據', '提示', {
                confirmButtonText: '確認',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await this.axios.post(this.pub.getApi().DeletePropertyDeal, { propertyDealID: row.propertyDealID }).then(res => {
                if (res.data.code == 0) {
                    this.success('删除成功');
                    this.firstLoading = true;
                    }
                });
                this.getTableData();
            }).catch(() => { })
        },
        // 添加,修改成交记录前 清除表单
        clearForm(){
            this.dealFormData = {};
            this.$refs.dealFormData.resetFields();
            this.dealFormData.verifyFile = [];
            this.filelist = [];
        },
        cancelDeal() {
            this.clearForm()
            this.isShowDeal = false;
        },
        onRemove(file, fileList) {
            for (let index = 0; index < this.dealFormData.verifyFile.length; index++) {
                if (file.uid == this.dealFormData.verifyFile[index].uid) {
                    this.dealFormData.verifyFile.splice(index, 1);
                }
            }
        },
        beforeUpload(file) {
            file.arrayBuffer().then(buffer => {
                const blob = new Blob([buffer], { type: file.type });
                let formData = new FormData();
                formData.append('file', blob, file.name);
                this.axios.post(this.pub.getApi().Upload, formData).then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.dealFormData.verifyFile.push({
                            name: file.name,
                            filePath: res.data.result[0].url
                        });
                    }
                    if(res.data.code !== 0){
                        this.error("请重新上傳")
                    }
                });
            });
        },
        async upfiles(value){
            console.log("upfiles")
        },
        handleExceed(files, fileList) {
            this.warning('已超過文件上傳數量限制');
        },
        phachange(item) {
            this.dealFormData.estateID = item.estateID;
        },
        setSelEstate(item){
            this.regionCode = '';
            this.zoneCode = '';
            this.gscopeCode = '';
            this.estateName = item.estateNameWithCulture;
        },
        setEstate(item) {
            this.dealFormData.estateName = item.estateNameWithCulture;
            // 根据parentid 在回显时 回显期数需要
            this.dealFormData.parentEstateID = item.estateID;
            this.axios
                .get(this.pub.getApi().GetPhasesAndBuildingForPublish, {
                    params: { estateId: item.estateID }
                })
                .then(res => {
                    this.phaseEstates = res.data.result.estatePhases;
                    if (!this.phaseEstates.length){this.dealFormData.estateID = item.estateID;} 
                });
        },
        dataFormat() {
            if (this.dealFormData.propertyCategoryArr.length > 1) {
                for (let index = 0; index < this.dealFormData.propertyCategoryArr.length; index++) {
                  const value = this.dealFormData.propertyCategoryArr[index];
                  if (value <= 5) {
                      this.dealFormData.propertyCategory = value;
                  } else {
                      this.dealFormData.subCategory = value;
                  }
                    // this.dealFormData.propertyCategoryArr[index] <= 5 ? (this.dealFormData.propertyCategory = this.dealFormData.propertyCategoryArr[index]) : (this.dealFormData.subCategory = this.dealFormData.propertyCategoryArr[index]);
                }
                delete this.dealFormData.propertyCategoryArr;
            } else{
                this.dealFormData.propertyCategory = this.dealFormData.propertyCategoryArr[0];
                this.dealFormData.subCategory = '';
                delete this.dealFormData.propertyCategoryArr;
            }
            for (const key in this.dealFormData) {
                if (this.dealFormData[key] === '' || JSON.stringify(this.dealFormData[key]) === '[]' || this.dealFormData[key] === null) {
                    delete this.dealFormData[key];
                    continue;
                }
            }
        },

        async validation(formName) {
            this.$refs[formName].validate(async valid => {
                if (valid) {
                    this.dataFormat();
                    if (this.viewMode == 'edit') {
                        await this.axios.post(this.pub.getApi().UpdatePropertyDeal, this.dealFormData).then(res => {
                            if (res.data.code == 0) {
                                this.success('成交數據修改成功');
                                this.isShowDeal = false;
                            } else {
                                this.error('成交數據修改失敗');
                            }
                        });
                    } else {
                        await this.axios.post(this.pub.getApi().AddPropertyDeal, this.dealFormData).then(res => {
                            if (res.data.code == 0) {
                                this.success('成交數據提交成功');
                                this.isShowDeal = false;
                            } else {
                                this.error('成交數據提交失敗');
                            }
                        });
                    }
                    this.getTableData();
                }
            });
        },
        addformrule(){
            this.rules.salePrice = [{ required: true, message:'請輸入放售價', trigger: 'blur' }];
            this.rules.rentPrice = [{ required: true, message: '請輸入每月租金', trigger: 'blur' }];
            this.rules.buildingArea= [{ required: true, message: '請輸入建築面積', trigger: 'blur' }];
            this.rules.saleableArea = [{ required: true, message: '請輸入實用面積', trigger: 'blur' }];
        },
        handleReqChange(typeData, requiredType) {
            //面積 價格 為數字
            this.dealFormData[typeData] = this.dealFormData[typeData].replace(/[^\d]/g, '');
            if((typeData == 'salePrice' || typeData == 'rentPrice' )&& this.dealFormData[typeData] <= 0){
                this.dealFormData[typeData] = ''
            }
            if (this.dealFormData[typeData]) {
                this.rules[requiredType] = [{ required: false, message: '', trigger: 'blur' }];
                this.$refs.dealFormData.clearValidate(requiredType);
                if (typeData == 'salePrice' || typeData == 'rentPrice') {this.dealFormData[requiredType] = '';}
            } else if (!this.dealFormData[typeData] && !this.dealFormData[requiredType]) {
                let array = [
                    { key: 'salePrice', value: '請輸入放售價', requiremes: '請輸入每月租金' },
                    { key: 'rentPrice', value: '請輸入每月租金', requiremes: '請輸入放售價' },
                    { key: 'buildingArea', value: '請輸入建築面積', requiremes: '請輸入實用面積' },
                    { key: 'saleableArea', value: '請輸入實用面積', requiremes: '請輸入建築面積' }
                ];
                let selArr = array.filter(item => item.key == typeData);
                this.rules[requiredType] = [{ required: true, message: selArr[0].requiremes, trigger: 'blur' }];
                this.rules[typeData] = [{ required: true, message: selArr[0].value, trigger: 'blur' }];
            }
        },

        async clickSearch() {
            const data = this.getSearchValue();
            await this.axios.post(this.pub.getApi().SearchPropertyDeal, data).then(res => {
                if (res.data.code == 0) {
                    this.dealTableData = res.data.result.data;
                    this.count = res.data.result.count;
                }
            });
        },
        getSearchValue() {
            const data = {};
            data.pageIndex = this.pageIndex;
            data.pageCount = this.pageCount;
            if (this.category) {
                this.categoryList.forEach(item => {
                    if (item.itemName == this.categoryIf[0]) {
                        if (item.children != null) {
                            // 二级筛选
                            if (item.children.length != this.categoryIf.length - 1 && this.categoryIf.length > 1){ data.SubCategory = this.categoryIf.slice(1);}
                            // 一级分类
                            if (item.children.length == this.categoryIf.length - 1){data.propertyCategory = this.categoryIf[0];} 
                        } else {
                            data.propertyCategory = this.categoryIf[0];
                        }
                    }
                });
            }
            if (this.propertyNo){data.propertyNo = this.propertyNo;} 
            if (this.categoryValue){data.categoryValue = this.categoryValue;} 
            // if (this.category) data.category = this.category;
            if (this.regionCode){data.regionCode = this.regionCode;} 
            if (this.zoneCode){data.zoneCode = this.zoneCode;} 
            if (this.gscopeCode){ data.gscopeCode = this.gscopeCode;}
            if (this.estateName){ data.estateName = this.estateName;}
            if (this.accountName){data.accountName = this.accountName;} 
            if (this.minSaleableArea){data.minSaleableArea = this.minSaleableArea;} 
            if (this.maxSaleableArea){data.maxSaleableArea = this.maxSaleableArea;} 
            if (this.minBuildingArea){ data.minBuildingArea = this.minBuildingArea;}
            if (this.maxBuildingArea){data.maxBuildingArea = this.maxBuildingArea;} 
            if (this.minCreateTime){data.minCreateTime = parseInt(this.minCreateTime / 1000);} 
            if (this.maxCreateTime){ data.maxCreateTime = parseInt(this.maxCreateTime / 1000 + 24 * 60 * 60);}
            if (this.minDealDate){ data.minDealDate = parseInt(this.minDealDate / 1000);}
            if (this.maxDealDate){data.maxDealDate = parseInt(this.maxDealDate / 1000 + 24 * 60 * 60);} 
            if (this.minRentPrice){data.minRentPrice = this.minRentPrice;} 
            if (this.maxRentPrice){data.maxRentPrice = this.maxRentPrice;} 
            // if (this.minSalePrice) data.minSalePrice = this.minSalePrice * 10000;
            if (this.minSalePrice){data.minSalePrice = this.minSalePrice ;} 
            // if (this.maxSalePrice) data.maxSalePrice = this.maxSalePrice * 10000;
            if (this.maxSalePrice){data.maxSalePrice = this.maxSalePrice;} 
            return data;
        },
        resetSearch() {
            this.propertyNo = '';
            this.categoryValue = '';
            this.category = '';
            this.categoryValueEnd = [];
            this.regionCode = '';
            this.zoneCode = '';
            this.gscopeCode = '';
            this.estateName = ''; //待定
            this.accountName = ''; //待定
            this.minRentPrice = '';
            this.maxRentPrice = '';
            this.minSalePrice = '';
            this.maxSalePrice = '';
            this.minSaleableArea = '';
            this.maxSaleableArea = '';
            this.minBuildingArea = '';
            this.maxBuildingArea = '';
            this.minDealDate = '';
            this.maxDealDate = '';
            this.minCreateTime = '';
            this.maxCreateTime = '';
            this.pageIndex = 1
            this.getTableData()
            this.getGscope()
        },
        priceChange(type) {
            if (type == 'rent') {
                this.minSalePrice = '';
                this.maxSalePrice = '';
            } else {
                this.minRentPrice = '';
                this.maxRentPrice = '';
            }
        },
        /** 搜索楼盘 */
        search(queryString, callback) {
            if (!queryString) {
                return;
            }
            this.axios
                .post(this.pub.getApi().SearchEstate, {
                    keywords: queryString,
                    pageIndex: 1,
                    pageCount: 50,
                    parentEstateID: 0
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.estate = res.data.result.data;
                        this.estate
                            .sort((a, b) => {
                                if (!a.phaseWithCulture && b.phaseWithCulture) {
                                    return -1;
                                } else if (a.phaseWithCulture && !b.phaseWithCulture) {
                                    return 1;
                                }
                                return 0;
                            })
                            .map(item => {
                                const { gscopeNameWithCulture, estateNameWithCulture, phaseWithCulture } = item;
                                item.value = gscopeNameWithCulture + ' ' + estateNameWithCulture + ' ' + (phaseWithCulture ? phaseWithCulture : '');
                                return item;
                            });
                        callback(this.estate);
                    }
                });
        },
        success(info) {
            this.$message({
                showClose: true,
                message: info,
                type: 'success',
                offset: document.body.clientHeight / 2
            });
        },
        warning(info) {
            this.$message({
                showClose: true,
                message: info,
                type: 'warning',
                offset: document.body.clientHeight / 2
            });
        },
        error(info) {
            this.$message({
                showClose: true,
                message: info,
                type: 'error',
                offset: document.body.clientHeight / 2
            });
        },
        handleScroll() {
            this.scrollValue = document.querySelector('.el-main').scrollTop;
        },
        cancelSearch() {
            this.dealFormData.estateName = ''
        },
        changeLinkage(type) {
            if (type == 'region') {
                this.zoneCode = ''
                this.gscopeCode = ''
                this.regionList.forEach(item => {
                    if (item.gscopeCode === this.regionCode) {
                        this.zoneList = item.children;
                    }
                });
                this.gscopeList=[]
            } else {
                this.gscopeCode = ''
                this.zoneList.forEach(item => {
                    if (item.gscopeCode === this.zoneCode) {
                        this.gscopeList = item.children;
                    }
                });
            }
        },
        categoryCascaderChange(val) {
            let ConversData = [];
            // 是否与上次的类型相同
            let changeFlag = false;
            let changeItem = null;
            if (this.categoryValueEnd.length == 0) {
                this.category = val;
            } else {
                // 与原数组比对
                this.category.forEach(item => {
                    if (item[0] !== this.categoryValueEnd[0][0]) {
                        // 一级标签不同
                        changeFlag = true;
                        changeItem = item;
                        ConversData.push(item);
                    } else if ((!item[2] && this.categoryValueEnd[0][2]) || (item[2] && !this.categoryValueEnd[0][2])) {
                        changeFlag = true;
                        changeItem = item;
                    }
                });
            }
            if (changeFlag) {
                this.category = [];
                this.category = ConversData;
            }
            function flatten(arr) {
                while (arr.some(item => Array.isArray(item))) {
                    //如果当前数组中还有数组，则展开
                    arr = [].concat(...arr);
                }
                return arr;
            }
            this.categoryValueEnd = this.category;
            let categoryValueEnd2 = flatten(this.category);
            this.categoryIf = [...new Set(categoryValueEnd2)];
            if (!this.category || !this.category.length) {
                this.categoryValue = '';
                return;
            }
            this.categoryValue = `樓盤類型(已選${this.category.length}個標籤)`;
        },

        publicTimeOption1(time) {
            if (this.minCreateTime) {
                return time.getTime() < this.minCreateTime;
            } 
                return false;
            
        },
        publicTimeOption3(time) {
            if (this.maxCreateTime) {
                return time.getTime() > this.maxCreateTime;
            } 
                return false;
            
        },
        dealTimeOption1(time) {
            if (this.minDealDate) {
                return time.getTime() < this.minDealDate;
            } 
                return false;
            
        },
        dealTimeOption3(time) {
            if (this.maxDealDate) {
                return time.getTime() > this.maxDealDate;
            } 
                return false;
            
        },
        clicLeftScroll(data) {
            let left = this.$(`.${data} .el-table__body-wrapper `).scrollLeft();
            this.$(`.${data} .el-table__body-wrapper`).animate({ scrollLeft: left + 200 }, 200);
        },
        clicRightScroll(data) {
            let left = this.$(`.${data} .el-table__body-wrapper `).scrollLeft();
            if (left >= 200) {
                this.$(`.${data} .el-table__body-wrapper `).animate({ scrollLeft: left - 200 }, 200);
            } else {
                this.$(`.${data} .el-table__body-wrapper `).animate({ scrollLeft: 0 }, 200);
            }
        },
        currentChange(pageIndex) {
            this.pageIndex = pageIndex;
            this.clickSearch()
        },
        sizeChange(data) {
            this.pub.userPageSize(this.$store.state.userInfo.accountID, 'dealPageCount', data);
            this.pageCount = data;
            this.clickSearch()
        }
    },
    computed: {
        ...mapGetters(['page', 'sideBar'])
    },
    watch: {
        scrollValue(val) {
            if (val >= 340) {
                this.isFixed = true;
            } else {
                this.isFixed = false;
            }
        }
    }
};
</script>

<style scoped lang="less">
/deep/.el-table__header .cell{
    line-height:16px;
}
/deep/.el-dialog {
    border-radius: 10px;
}
/deep/ .el-dialog__header {
    padding: 0;
    padding-left: 20px;
    height: 45px;
    line-height: 45px;
    box-sizing: border-box;
    border-radius: 10px 10px 0 0;
    background: #fafafb;
    border-bottom: 1px solid #eee;
    .el-dialog__title {
        font-size: 16px;
        color: #92929d;
    }
    .el-dialog__headerbtn {
        top: 12px;
    }
}
.footer {
    input {
        border-radius: 4px;
    }
    span {
        font-size: 14px;
        color: #44444f;
        margin-left: 16px;
    }
    margin-top: 16px;
    padding-top: 20px;
    // box-sizing: border-box;
    height: 72px;
    .page {
        float: right;
    }
    .input-number {
        input {
            border-radius: 0px;
        }
        text-align: left;
        float: right;
        width: 70px;
    }
    /**覆盖计数器样式 */
    .el-input-number.is-controls-right .el-input__inner {
        padding-left: 8px;
        padding-right: 42px;
        overflow: hidden;
    }
}
.left-right-scorll {
    width: 100%;
    width: calc(100% - 160px);
    margin-top: 12px;
    height: 24px;
    text-align: center;
    position: fixed;
    bottom: 48px;
    span {
        margin: 0 48px;
        display: inline-block;
        position: relative;
        height: 30px;
        height: 30px;
        width: 52px;
        cursor: pointer;
        overflow: hidden;
        border-radius: 4px;
        &:hover {
            background-color: #ccc;
        }
    }
    .icon {
        font-size: 68px;
        position: absolute;
        left: -6px;
        top: -20px;
        z-index: 99;
    }
}
.btn-text {
    cursor: pointer;
    position: relative;
    top: 0px;
    font-size: 15px;
    padding-left: 5px;
    color: #0062ff;
}
.ban {
    color: #666;
}
.disspan {
    pointer-events: none;
}
/deep/.el-form-item__label {
    min-width: 150px !important;
}
.el-form-item__label + .el-form-item__content {
    margin-top: 0.2em; /* 调整 label 和 content 的上下间隙 */
}
/deep/.labelspan .el-form-item__label {
    line-height: 25px !important;
}
/deep/.areaspan .el-form-item__label {
    min-width: 111px !important;
}
/deep/.el-form-item__error {
    margin-left: 150px;
}
/deep/.areaspan .el-form-item__error {
    margin-left: 111px;
}
// .el-col:not(:last-child) {
//     margin-right: 100px;
// }
.property-tags-cascader-none-li {
    display: none;
}
.property-tags-cascader-panelcheckbox.el-cascader-panel.is-bordered {
    border: none;
    .el-scrollbar__view.el-cascader-menu__list {
        padding: 0;
    }
}
.container {
    background-color: #f3f3f5;
    padding: 0;
    margin: 0;
    text-align: left;
    .w180 {
        width: 180px;
    }
    .line {
        width: 100%;
        height: 1px;
        background-color: #e2e2ea;
    }
    .button2 {
        height: 74px;
        overflow: hidden;
    }
    .btn-text {
        cursor: pointer;
        position: relative;
        top: 0px;
        font-size: 15px;
        padding-left: 5px;
        color: #0062ff;
    }
    .ban {
        color: #666;
    }
    .table {
        .btn-a {
            color: #0062ff;
        }
        .fixColumm {
            border-left: 1px solid rgba(51, 51, 51, 0.1);
            box-shadow: -10px 0px rgba(234, 234, 234, 0.2) !important;
            line-height: 24px;
            .editBut {
                width: 52px;
                height: 24px;
                padding: 0;
                text-align: center;
                border-radius: 6px;
            }

            .marBut {
                margin-left: 10px;
            }
            .expandBut {
                margin-left: 0;
                width: 24px;
                height: 24px;
                display: inline-block;
                padding: 0;
                text-align: center;
                border-radius: 6px;
            }
        }
        .el-button {
            text-align: left;
            width: 100%;
        }
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 20px;
        padding: 20px;
        box-sizing: border-box;
        .el-table__header tr,
        .el-table__header th {
            padding: 0 !important;
            height: 38px;
        }
        /**修改表格背景 */
        .el-table tbody tr:hover > td {
            background-color: rgba(80, 181, 255, 0.1) !important;
        }
        /** */
        /deep/ .el-table thead tr {
            th:first-child {
                border-radius: 10px 0 0 10px;
            }
            th:nth-last-child(2) {
                border-radius: 0 10px 10px 0;
            }
        }
        .el-table th {
            border: none;
        }
        /**分割线 */
        .el-table td {
            border-bottom: 1px solid #e2e2ea;
        }
        table {
            .btn-table {
                color: #222;
            }
            .btndisable {
                pointer-events: none;
            }
            color: #222;
            font-size: 14px;
            tr th .cell {
                line-height: 38px;
                font-weight: normal;
                font-size: 13px;
                color: #444444;
            }
        }
    }
    .dealclass {
        .labelspan {
            line-height: 25px !important;
        }
        .deal-tishi {
            padding-left: 0;
            .deal-row {
                width: 960px;
                position: relative;
                .tip{
                    position:absolute;
                    top:17px;
                    left:260px;
                }
                .upload-demo{
                    display:inline-block;
                    margin-right: 8px;
                    span{
                        color:#444444;
                        font-size: 14px;
                    }
                    
                }
            }
        }
    }
    .button {
        top: 50px;
        z-index: 999;
        padding: 10px 0px 12px 0px;
        box-sizing: border-box;
        background-color: #f3f3f5;
        overflow: hidden;
        margin-bottom: 6px;
        .span {
            margin-top: 14px;
            position: relative;
            top: -2px;
            cursor: pointer;
            display: inline-block;
            padding: 0 14px 0 0;
            .icon {
                font-size: 20px;
            }
            .btn-text {
                position: relative;
                top: 0px;
                font-size: 15px;
                padding-left: 5px;
                color: #0062ff;
            }
            .ban {
                color: #666;
            }
        }
    }
    /**固定操作栏 */
    /**固定 */
    .fixed-1 {
        padding: 12px 24px 12px 30px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
        position: fixed;
        left: 170px;
        width: calc(100% - 140px);
        transform: translateX();
        transition-duration: 1s;
    }
    /**宽度改变 */
    .fixed-2 {
        width: calc(100% - 60px);
        left: 60px;
    }
    /**解决 */
    .fixed {
        width: 100%;
    }
    input {
        color: #000;
        font-size: 14px;
        border: none;
        border-radius: 10px;
        height: 38px;
    }
    .title {
        padding: 0 0 20px 0;
        font-size: 24px;
        color: #171725;
        .span {
            padding-right: 16px;
            font-size: 14px;
            color: #0062ff;
        }
    }
    .filter {
        padding-bottom: 16px;
        .seled {
            ::placeholder {
                color: #000000;
            }
        }
        /deep/.el-input__inner {
            border-radius: 10px !important;
        }
        .btn-filter {
            padding-left: 10px;
            display: inline-block;
            padding-bottom: 16px;
            .el-button--danger {
                background: #e50113;
            }
        }
        input {
            color: #000;
            font-size: 14px;
            border: none;
            border-radius: 10px;
            height: 38px;
        }
        button {
            border-radius: 10px;
            width: 88px;
            height: 38px;
        }
        .w90,
        .w135,
        .w150,
        .w160,
        .w280,
        .w120,
        .w100,
        .w180,
        .w195,
        .w245,
        .w105,
        .w315 {
            margin-right: 15px;
            margin-bottom: 10px;
        }
        .mr4 {
            margin-right: 5px;
        }
        .w90 {
            width: 90px;
        }
        .w100 {
            width: 100px;
        }
        .w105 {
            width: 105px;
        }
        .w135 {
            width: 135px;
        }
        .w150 {
            width: 150px;
        }
        .w160 {
            width: 160px;
        }
        .w180 {
            width: 180px;
        }
        .w195 {
            width: 195px;
        }
        .w280 {
            width: 280px;
        }
        .w315 {
            width: 315px;
        }
        .w245 {
            width: 245px;
        }
        span.time {
            font-size: 14px;
            color: #666;
        }
        .input-model {
            box-sizing: border-box;
            display: inline-block;
            height: 38px;
            line-height: 38px;
            border-radius: 10px;
            padding: 0 8px;
            font-size: 14px;
            color: #333;
            .w105,
            .w90 {
                margin: 0;
            }
            .pm {
                margin: 0 6px;
            }
            /deep/ .el-input__inner {
                padding: 0 8px;
                line-height: 38px;
                height: 36px;
            }
        }
        /**楼盘标签相关 */
        .property-tags-cascader {
            position: relative;
            display: inline-block;
        }
    }
}
</style>
